import { render, staticRenderFns } from "./car-uses.vue?vue&type=template&id=9fe148c0&"
import script from "./car-uses.vue?vue&type=script&lang=js&"
export * from "./car-uses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports